export default (() => {
  console.log("Component Two Functionality");
});